/* IMPORT
-------------------------------------------------------------- */

import {
  // SVG
  deanOneLogo,
  deanOneHeaderMijn,
  deanOneviewLogo,
  deanOneBg,
  goLogo,
  goHeaderCloud,
  goBg,
  gammaLogo,
  gammaHeaderWholesale,
  gammaBg,
  schipholConnectLogo,
  schipholConnectHeader,
  schipholConnectBg,
} from '@deanone/dean-components';

/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

/* STORE
-------------------------------------------------------------- */
import store from '../';

/* STATE
-------------------------------------------------------------- */
import { ThemesState } from './';

const state: ThemesState = {
  theme: {
    data: {
      name: 'gamma',
      title: 'Gamma',
      logo: gammaLogo,
      headerLogo: gammaHeaderWholesale,
      loginLogo: gammaLogo,
      bgLogo: gammaBg,
      colors: {
        colorPrimary: '#6800D2',
        colorSecondary: '#7653F3',
        colorLink: '#7653F3',
        colorDark: '#3E425B',
        colorLight: '#E8E8EF', // "#E4E4F2", "#DFE0E8"
      },
    },
    styles: {},
  },
};

/* MUTATIONS
-------------------------------------------------------------- */
import { SET_THEME, SET_THEME_STYLES } from './types';

const mutations = {
  [SET_THEME](themeState: any, data: any) {
    themeState.theme.data = data;
  },
  [SET_THEME_STYLES](themeState: any, data: any) {
    themeState.theme.styles = data;
  },
};

/* ACTIONS
-------------------------------------------------------------- */
const actions = {
  // @ts-ignore-next-line
  async reqTheme({commit}, data: any) {

    const available: {
      [key: string]: any,
    } = {
      deanone: {
        name: 'deanone',
        title: 'Oneview',
        logo: deanOneLogo,
        headerLogo: deanOneHeaderMijn,
        loginLogo: deanOneLogo,
        bgLogo: deanOneBg,
        colors: {
          colorPrimary: '#D70019',
          colorSecondary: '#FF812F',
          colorLink: '#000',
          colorDark: '#53565A',
          colorLight: '#E5E5E6',
        },
      },
      oneview: {
        name: 'deanone',
        title: 'Oneview',
        logo: deanOneLogo,
        headerLogo: deanOneviewLogo,
        loginLogo: deanOneLogo,
        bgLogo: deanOneBg,
        colors: {
          colorPrimary: '#D70019',
          colorSecondary: '#FF812F',
          colorLink: '#000',
          colorDark: '#53565A',
          colorLight: '#E5E5E6',
        },
      },
      go: {
        name: 'go',
        title: 'Oneview',
        logo: goLogo,
        headerLogo: goHeaderCloud,
        loginLogo: goLogo,
        bgLogo: goBg,
        colors: {
          colorPrimary: '#000000',
          colorSecondary: '#D70019',
          colorLink: '#53565A',
          colorDark: '#53565A',
          colorLight: '#E5E5E6',
        },
      },
      gamma: {
        name: 'gamma',
        title: 'Gamma',
        logo: gammaLogo,
        headerLogo: gammaHeaderWholesale,
        loginLogo: gammaLogo,
        bgLogo: gammaBg,
        colors: {
          colorPrimary: '#6800D2',
          colorSecondary: '#7653F3',
          colorLink: '#7653F3',
          colorDark: '#3E425B',
          colorLight: '#E8E8EF', // "#E4E4F2", "#DFE0E8"
        },
      },
      schipholconnect: {
        name: 'schipholconnect',
        title: 'Schiphol Connect',
        logo: schipholConnectLogo,
        headerLogo: schipholConnectHeader,
        bgLogo: schipholConnectBg,
        colors: {
          colorPrimary: '#005776',
          colorSecondary: '#7ba7bc',
          colorLink: '#ED8B00', // '#7ba7bc',
          colorDark: '#53565A',
          colorLight: '#EAEBEA',
        },
      },
    };

    if (data != null) {

      const shade = (hex: any, lum: any) => {
        //  VALIDATE HEX STRING
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;

        // CONVERT TO DEXIMAL AND CHANGE LUMINOSITY
        let rgb = '#';
        for (let i = 0; i < 3; i++) {
          let c: string | number = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
          rgb += ('00' + c).substr(c.length);
        }

        return String(rgb);
      };

      const colors = {
        colorPrimary: available[data].colors.colorPrimary,
        colorSecondary: available[data].colors.colorSecondary,
        colorLink: available[data].colors.colorLink,
        colorDark: available[data].colors.colorDark,
        colorLight: available[data].colors.colorLight,
      };

      const styles: any = {
        '--color-primary': colors.colorPrimary,
        '--color-primary-shade-1': shade(colors.colorPrimary, 0.2),
        '--color-primary-shade-2': shade(colors.colorPrimary, 0.4),
        '--color-primary-shade-3': shade(colors.colorPrimary, 0.6),
        '--color-primary-shade-4': shade(colors.colorPrimary, 0.8),
        '--color-secondary': colors.colorSecondary,
        '--color-secondary-shade-1': shade(colors.colorSecondary, 0.2),
        '--color-secondary-shade-2': shade(colors.colorSecondary, 0.4),
        '--color-secondary-shade-3': shade(colors.colorSecondary, 0.6),
        '--color-secondary-shade-4': shade(colors.colorSecondary, 0.8),
        '--color-link': colors.colorLink,
        '--color-link-shade-1': shade(colors.colorLink, 0.2),
        '--color-link-shade-2': shade(colors.colorLink, 0.4),
        '--color-link-shade-3': shade(colors.colorLink, 0.6),
        '--color-link-shade-4': shade(colors.colorLink, 0.8),
        '--color-dark': colors.colorDark,
        '--color-dark-shade-1': shade(colors.colorDark, 0.2),
        '--color-dark-shade-2': shade(colors.colorDark, 0.4),
        '--color-dark-shade-3': shade(colors.colorDark, 0.6),
        '--color-dark-shade-4': shade(colors.colorDark, 0.8),
        '--color-light': colors.colorLight,
        '--color-light-shade-1': shade(colors.colorLight, 0.03),
        '--color-light-shade-2': shade(colors.colorLight, 0.05),
        '--color-light-shade-3': shade(colors.colorLight, 0.07),
        '--color-light-shade-4': shade(colors.colorLight, 0.09),
      };

      // GO! specific coloring. Needs removal eventually.
      if (data === 'go') {
        styles['--color-info-standard'] = 'black';
      }

      commit('SET_THEME', available[data]);
      commit('SET_THEME_STYLES', styles);

    } else {
      const host = window.location.href;

      if (((host.indexOf('compleet') > 0) && (host.indexOf('mijn.compleet') < 0))) {
        store.dispatch('reqTheme', 'oneview');
      } else if (host.indexOf('go') > 0) {
        store.dispatch('reqTheme', 'gamma');
      } else if (host.indexOf('wholesale') > 0) {
        store.dispatch('reqTheme', 'gamma');
      } else if (host.indexOf('schiphol') > 0) {
        store.dispatch('reqTheme', 'schipholconnect');
      }  else if (host.indexOf('oneview') > 0) {
        store.dispatch('reqTheme', 'gamma');
      } else {
        store.dispatch('reqTheme', 'deanone');
      }
    }
  },
};

/* GETTERS
-------------------------------------------------------------- */
const getters = {
  getTheme: (themeState: { theme: any; }) => {
    return themeState.theme;
  },
};

/* EXPORT
-------------------------------------------------------------- */
export const ThemesData = {
  state,
  actions,
  mutations,
  getters,
};
